import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import { SharedService} from '../services/shared-service/shared.service';
import { NavbarComponent } from './menus/top-navbar/top-navbar.component';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  pageTitle: any;
  rtl = false;
  @Input() openedSidebar = false;

  constructor(public router: Router, public _sharedService: SharedService) {
    _sharedService.changeEmitted$.subscribe(
      title => {
        this.pageTitle = title;
      });
  }

  ngOnInit() { }

  getClasses() {
    return {
      'open-sidebar': this.openedSidebar,
      'rtl': this.rtl
    };
  }

  sidebarState() {
    this.openedSidebar = !this.openedSidebar;
  }
}



// WEBPACK FOOTER //
// ./src/app/Dashboard/dashboard.component.ts